import React from 'react';
import { Popover } from 'react-bootstrap';

export const UploadBoundaryFilePopover = (
  <Popover id="upload-boundary-file-popover">
    <Popover.Body className="p-3 font-sans-serif">
      <p className="mb-0 fs--2">
        <span className="text-primary fw-bold">File Types: </span> This upload
        supports two file formats: <strong>.geojson and .csv.</strong> Please
        make sure your files have the correct extension before uploading. Files
        in any other format will not be accepted.&nbsp;
        <span className="d-inline-block">
          <span className="text-primary fw-bold">File Structure: </span>
          Ensure that your <strong>.geojson and .csv</strong> files adhere to
          the required structure and data specifications for proper processing.
          Refer to the sample template file for guidance.
        </span>
      </p>
    </Popover.Body>
  </Popover>
);
export const DownloadBoundaryTemplatePopover = (
  <Popover id="download-boundary-template-popver">
    <Popover.Body className="p-3 font-sans-serif">
      <p className="mb-0 fs--2">
        Before uploading your own data, we recommend downloading and referring
        to the sample template file for a correctly formatted example. This file
        showcases the expected structure and provides valuable insights on how
        to prepare your data.
      </p>
    </Popover.Body>
  </Popover>
);
